import { Article } from '@article/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { StateWithArticle } from '../article-state';
import { getArticleState } from './feature.selector';

export const getArticleDetailState: MemoizedSelector<
  StateWithArticle,
  StateUtils.EntityLoaderState<Article>
> = createSelector(getArticleState, (state) => state.article);

export const getArticle = (code: string): MemoizedSelector<StateWithArticle, StateUtils.LoaderState<Article>> =>
  createSelector(getArticleDetailState, (state) => StateUtils.entityLoaderStateSelector(state, code));

export const getArticleValue = (code: string): MemoizedSelector<StateWithArticle, Article> =>
  createSelector(getArticleDetailState, (state) => StateUtils.entityValueSelector(state, code));

export const getArticleLoading = (code: string): MemoizedSelector<StateWithArticle, boolean> =>
  createSelector(getArticleDetailState, (state) => StateUtils.entityLoadingSelector(state, code));

export const getArticleError = (code: string): MemoizedSelector<StateWithArticle, boolean> =>
  createSelector(getArticleDetailState, (state) => StateUtils.entityErrorSelector(state, code));

export const getArticleSuccess = (code: string): MemoizedSelector<StateWithArticle, boolean> =>
  createSelector(getArticleDetailState, (state) => StateUtils.entitySuccessSelector(state, code));
